import axios from "axios";

const instance = axios.create({
  baseURL: "https://xpao3ln305.execute-api.us-east-1.amazonaws.com/BI/",
  timeout: 120000
});

export default instance;